/**
 * PAPPO — AlertBadge Component
 * Badge colorido que mostra o nível de risco usando RISK_COLORS e RISK_LABELS.
 */

import type { RiskCategory, RiskLevel } from '../../types/alert';
import { RISK_COLORS, RISK_LABELS } from '../../types/alert';
import styles from './AlertBadge.module.css';

interface AlertBadgeProps {
  /** Categoria de risco */
  category: RiskCategory;
  /** Nível de risco (1-5) */
  level: RiskLevel;
  /** Tamanho */
  size?: 'sm' | 'md';
  /** Classe adicional */
  className?: string;
}

export function AlertBadge({ category, level, size = 'md', className = '' }: AlertBadgeProps) {
  const color = RISK_COLORS[category];
  const label = RISK_LABELS[category];

  return (
    <span
      className={`${styles.badge} ${styles[size]} ${className}`}
      style={{ backgroundColor: color }}
      title={`${label} — Nível ${level}/5`}
      role="status"
      aria-label={`Risco: ${label}, nível ${level} de 5`}
    >
      <span className={styles.label}>{label}</span>
      <span className={styles.level}>{level}</span>
    </span>
  );
}
